import _objectSpread from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Cookie from "js-cookie";
import { QS } from "@/lib/utils";
import { IS_SEA } from "@/utils/index.js";
import { addParamsToUrl } from "@/lib/utils.ts";
import { LANG_MAPS } from "@/lib/i18nwordConfig";
const __default__ = {
  data() {
    return {
      IS_SEA,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      langList: LANG_MAPS
    };
  },
  methods: {
    onSelect(action) {
      const {
        lang
      } = useCommon();
      if (lang === action.value) {
        this.showPopover = false;
        return;
      }
      const params = _objectSpread(_objectSpread({}, QS), {}, {
        lang: action.value
      });
      const url = addParamsToUrl(`${location.origin}${location.pathname}`, params);
      Cookie.set("mi18nLang", action.value);
      window.location.replace(url + location.hash);
    },
    outside(e) {
      this.showPopover = false;
    }
  }
};
import { vOnClickOutside } from "@vueuse/components";
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'index',
  setup(__props) {
    const {
      lang
    } = useCommon();
    const langIndex = computed(() => LANG_MAPS.findIndex(({
      value
    }) => value === lang));
    return {
      __sfc: true,
      lang,
      langIndex,
      IS_SEA,
      vOnClickOutside
    };
  }
});